import { container } from 'tsyringe';
import { useEffect, useState } from 'react';
import {
  RequestTournamentsList,
  TournamentsService,
  Tourney,
} from '@base/features/tournaments/model/interfaces';
import {
  months,
  startIn,
} from '../components/tournamentsAdditionalInfo/tournamentsAdditionalInfo';
import { ResponseError } from '@base/features/auth/model/interfaces';
import { isResponseError } from '../../auth/utils/typequards';

type useTournamentBannerType = {
  showBanner: boolean;
  loaded: boolean;
  startTime: string;
  directorName: string;
  rules: string;
  entryFee: number | null;
  time: number | null;
};

export const useTournamentBanner = (): useTournamentBannerType => {
  const tournamentsService: TournamentsService = container.resolve(
    'tournamentsService'
  );

  const [loaded, setLoaded] = useState(false);
  const [time, setTime] = useState<null | number>(null);
  const [startTime, setStartTime] = useState('');
  const [directorName, setDirectorName] = useState('');
  const [rules, setRules] = useState('');
  const [entryFee, setEntryFee] = useState<null | number>(null);
  const [showBanner, setShowBanner] = useState(false);

  function getTimeStart(tourney: Tourney): string {
    const time = startIn(tourney.StartTimeUTC.toString());
    const minutes =
      new Date(time).getMinutes() < 10
        ? `${new Date(time).getMinutes()}0`
        : new Date(time).getMinutes();
    return `${months[new Date(time).getMonth()]} ${new Date(
      time
    ).getDate()}, ${new Date(time).getHours()}:${minutes}`;
  }

  function checkTimeStart(tourney: Tourney): boolean {
    const timeForShowBanner = 900000;
    const time = startIn(tourney.StartTimeUTC.toString());
    const date = Date.now();
    const timeStart = time - date;
    return timeStart <= timeForShowBanner;
  }

  useEffect(() => {
    tournamentsService
      .getTournamentsListForGameId()
      .then((response: RequestTournamentsList | ResponseError) => {
        if (!isResponseError(response)) {
          if (response['P'].length === 0) return;
          const tourney = response['P'][0];
          setTime(startIn(tourney.StartTimeUTC.toString()));
          setStartTime(getTimeStart(tourney));
          setDirectorName(tourney.DirectorName);
          setRules(tourney.Name);
          setEntryFee(tourney.EntryFee);
          setLoaded(true);
          setShowBanner(checkTimeStart(tourney));
        } else {
          setLoaded(false);
        }
      });

    const fetchData = setInterval(() => {
      tournamentsService.getTournamentsListForGameId().then((response) => {
        if (!isResponseError(response)) {
          if (response['P'].length === 0) return;
          const tourney = response['P'][0];
          setTime(startIn(tourney.StartTimeUTC.toString()));
          setStartTime(getTimeStart(tourney));
          setDirectorName(tourney.DirectorName);
          setRules(tourney.Name);
          setEntryFee(tourney.EntryFee);
          setLoaded(true);
          setShowBanner(checkTimeStart(tourney));
        } else {
          setLoaded(false);
        }
      });
    }, 60000);
    return () => clearInterval(fetchData);
  }, [tournamentsService]);

  return {
    showBanner,
    startTime,
    directorName,
    rules,
    entryFee,
    time,
    loaded,
  };
};
